module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authorized) ? _c('v-list-tile', {
    on: {
      "click": _vm.route
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(_vm.item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.item.title))])], 1), _vm._v(" "), (_vm.group) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a44ca26c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationItem.vue
// module id = 1092
// module chunks = 1